// Navigation configuration with TypeScript interfaces

export interface NavigationItem {
  path: string;
  title: string;
  icon: string;
  roles?: string[]; // Optional: roles that can see this item
  mainBranchOnly?: boolean; // Optional: only show for main branch admins
}

const navigation: NavigationItem[] = [
  {
    path: "/dashboard",
    title: "Статистика",
    icon: "dashboard",
  },
  {
    path: "/branches",
    title: "Филиалы",
    icon: "branch",
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/users",
    title: "Пользователи",
    icon: "users",
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/brands",
    title: "Бренды",
    icon: "brand",
  },
  {
    path: "/models",
    title: "Модели",
    icon: "model",
  },
  {
    path: "/products",
    title: "Каталог",
    icon: "car",
  },
  {
    path: "/video-reviews",
    title: "Видеоотзывы",
    icon: "video-testimonial",
    mainBranchOnly: true,
  },
  {
    path: "/review",
    title: "Отзывы",
    icon: "testimonial",
    mainBranchOnly: true,
  },
  {
    path: "/faq",
    title: "FAQ",
    icon: "faq",
    mainBranchOnly: true,
  },
];

// Helper function to filter navigation based on user role and branch
export const getNavigationForRole = (
  userRole: string,
  admin?: { branch?: { isMainBranch?: boolean } }
): NavigationItem[] => {
  return navigation.filter((item) => {
    // Check role-based visibility
    if (item.roles && item.roles.length > 0) {
      if (!item.roles.includes(userRole)) {
        return false;
      }
    }

    // Check if item requires main branch and admin is not from main branch
    if (item.mainBranchOnly && admin?.branch?.isMainBranch === false) {
      return false;
    }

    return true;
  });
};

export default navigation;
